import usePublicSearchContext from '@/publicSearch/store/usePublicSearchContext';
import type { Society } from '@/publicSearch/store/usePublicSearchContext';

/**
 * True when the society is i4-sourced (BreedLogicSocietyId is null in RPT.Societies).
 * Use this to show/hide i4-only features (Downloads, Online Registrations, link account).
 */
export function isI4Society(society: Society): boolean {
  return society.breedLogicSocietyId == null;
}

/**
 * Hook: whether the current public-search society is i4-sourced.
 * Use in components under the public search layout.
 */
export function useIsI4Society(): boolean {
  return usePublicSearchContext((s) => isI4Society(s.society));
}
